import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { orderBy } from 'lodash';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Response, Service, ServiceTypesEnum } from '../../../models';
import { AuthenticationService, DialogService, ProcessorService, ServicesService, SnackbarService } from '../../../services';
import { DownloadService } from '../../../services/standard/download.service';
import { BriefModalComponent } from '../../brief-modal/brief-modal.component';
import { UploaderModalComponent } from '../../uploader-modal/uploader-modal.component';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { ShowDownloadsComponent } from '../show-downloads/show-downloads.component';

@Component({
  selector: 'prism-jobs-table',
  templateUrl: './jobs-table.component.html',
  styleUrls: ['./jobs-table.component.scss']
})
export class JobsTableComponent implements OnInit, OnDestroy {
  servicesLoading$: Observable<boolean>;
  columnHeaders: string[];
  servicesList: MatTableDataSource<Service>;
  openingBrief: boolean;
  downloadProgress: {};
  paginatorControl: {
    length: number,
    pageSize: number,
    pageSizeOptions: number[]
  };

  constructor(
    private dialogService: DialogService,
    private snackbarService: SnackbarService,
    private downloadService: DownloadService,
    private servicesService: ServicesService,
    private processorService: ProcessorService,
    private authService: AuthenticationService
  ) {
    this.servicesLoading$ = this.servicesService.areServicesLoading$.pipe(debounceTime(0));
    if (this.authService.hasInvoicingPermissions) {
      this.columnHeaders = ['id', 'member', 'address', 'received', 'status', 'type', 'finals', 'raws', 'brief', 'add', 'confirmation', 'assets'];
    } else {
      this.columnHeaders = ['id', 'member', 'address', 'received', 'status', 'type', 'finals', 'raws', 'brief', 'add', 'assets'];
    }
    this.servicesList = new MatTableDataSource<Service>([]);
    this.openingBrief = false;
    this.downloadProgress = this.servicesService.downloadProgress;
    this.paginatorControl = {
      length: 0,
      pageSize: 10,
      pageSizeOptions: [10, 20, 40, 50, 100]
    };
  }

  @Input()
  set setServices(services: Service[]) {
    if (services) {
      this.servicesList.data = orderBy(services, job => job.received, 'desc');
      console.log(this.servicesList.data);
    }
  }

  @Input()
  set servicesCount(count: number) {
    this.paginatorControl.length = count;
  }

  @Input() pageIndex = 0;

  @Output()
  serviceSelected = new EventEmitter<any>();

  @Output()
  paginationEvent = new EventEmitter<PageEvent>();

  @Output()
  confirmationSuccess = new EventEmitter<void>();

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    mp.length = this.paginatorControl.length;
  }

  ngOnInit() {
  }

  openJobConfirmationDialog(service: Service) {
    const dialog = this.dialogService.openDialog(ConfirmationComponent, {
      serviceType: service.serviceType,
      job: service
    }, {panelClass: 'base-modal-dialog', width: '600px'});
    dialog.afterClosed().subscribe((confirmationIds: string[] = []) => {
      if (confirmationIds.length > 0) {
        service.confirmationIds = confirmationIds;
        this.confirmationSuccess.emit();
      }
    });
  }

  openAssetsDownloadDialog(job: Service) {
    this.snackbarService.showSnackbar('Fetching download information.');
    this.downloadService.getDownloadData(job.id)
      .subscribe(
        (downloadDataResponse: Response) => {
          const downloadData = downloadDataResponse.data;
          const dialogRef = this.dialogService.openDialog(ShowDownloadsComponent, {downloadData, job}, {panelClass: 'base-modal-dialog'});
          dialogRef.afterClosed()
            .toPromise()
            .then(
              () => this.servicesService.clearDownloadData()
            );
        }
      );
  }

  openBriefModal(job: Service) {
    this.openingBrief = true;
    this.servicesService.setSelectedService(job);
    const briefDialogRef = this.dialogService.openDialog(BriefModalComponent, {briefs: job.briefs}, {panelClass: 'base-modal-dialog'});
    briefDialogRef.afterClosed()
      .toPromise()
      .then(() => {
        this.openingBrief = false;
      });
  }

  setPaginator(pageEvent: PageEvent) {
    this.paginationEvent.emit(pageEvent);
  }

  addAssets(service) {
    this.processorService.processor$.subscribe((processor) => {
      if (processor) {
        this.dialogService.openDialog(UploaderModalComponent, {
          jobsCount: this.servicesService.serviceCount,
          service: service
        }, {
          height: '90vh',
          panelClass: 'base-modal-dialog'
        });
      }
    });
  }

  ngOnDestroy() {
  }

  protected readonly ServiceTypesEnum = ServiceTypesEnum;
}
